<template>
  <pop-view @onCloseClick="onCloseClick">
    <div class="add-device">
      <div class="add-device-top">
        <p class="add-device-top-title">
          指环数据上传智能诊断
          <span class="add-device-top-title-tip">*请先保证用户已上传所有日志</span>
        </p>
        <img class="add-device-top-close" src="@imgs/close-card.png" @click="onCloseClick" />
      </div>
      <div class="add-device-content">
        <div class="add-device-content-top">
          <el-input placeholder="请输入设备SN" v-model="sn">
          </el-input>
          <div style="font-size: 14px;">诊断类型：</div>
          <el-select v-model="diagnoseType" placeholder="诊断类型">
            <el-option v-for="item in diagnoseTypeList" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
          <el-date-picker size="mini" v-model="duration" type="datetimerange" value-format="timestamp"
            range-separator="至" start-placeholder="设置定时日期" end-placeholder="收取报告日期"
            :default-time="['00:00:00', '23:59:59']">
          </el-date-picker>
          <button class="add-device-content-top-diagnose" @click="onDiagnose">开始诊断</button>
        </div>
        <div class="add-device-content-result">
          <div v-if="resultArray.length" class="add-device-content-result-data-upload-table">
            <el-table :data="resultArray" border style="width: 100%">
              <el-table-column prop="period" label="定时时间" :width="150"></el-table-column>
              <el-table-column prop="message" label="信息" :min-width="120">
                <template slot-scope="scope">
                  {{ scope.row.message }}
                  <br/>
                  <!-- 整合兆冠日志（把兆冠SDK日志整合到一起）：<el-button type="primary" size="mini" @click="arrayToTxtDownload()">下载</el-button> -->
                </template>
              </el-table-column>
            </el-table>
          </div>
          <p v-if="isQueryComplete && !resultArray.length" class="add-device-content-result-ring-log-table-result">
            该指环在查询周期内<span style="font-weight: bold; color: #F45C50">
              没分析出问题 </span>。</p>
        </div>
      </div>
    </div>
  </pop-view>
</template>

<script>
import PopView from "@c/common/pop-view.vue";
import KeywordSearch from "@c/operation-log/common/filter-bar/keyword-search.vue";
import { Input, Button } from "element-ui";
import { DateTool } from "@js/date-tool.js";
import { SmartDiagnoseAlertDataUploadModel } from "@c/operation-log/bloodoxy/smart-diagnose-alert/smart-diagnose-alert-data-upload-model.js";
import { SmartDiagnoseAlertRingLogModel } from "@c/operation-log/bloodoxy/smart-diagnose-alert/smart-diagnose-alert-ring-log-model.js";
import dayjs from 'dayjs'

const SmartDiagnoseEnum = [
  {
    code: 1,
    mesage: '未设置定时'
  },

  {
    code: 2,
    mesage: '定时信息丢失'
  },


]

export default {
  components: {
    PopView,
    KeywordSearch,
    ElInput: Input,
    ElButton: Button,
  },

  model: {
    prop: "isShowAlert",
    event: "onCloseClick"
  },

  data() {
    return {
      //请求
      sn: undefined,
      duration: undefined,
      //列表
      dataLogArray: [],
      ringLogArray: [],
      periodLogArray: [],
      zhaoguanFileLogArray: [],
      resultArray: [],
      isQueryComplete: false,
      diagnoseType: 1,
      diagnoseTypeList: [
        {
          value: 1,
          label: '定时后收取无数据'
        },
        {
          value: 2,
          label: '报告时长为0、数据疑问'
        },
      ]
    };
  },

  methods: {
    onCloseClick() {
      this.$emit("onCloseClick");
    },

    onDiagnose() {
      if (!this.sn || !this.duration) {
        this.$toast.showRed("查询条件不能为空")
        return
      }
      this.dataLogArray = []
      this.ringLogArray = []
      this.periodLogArray = []
      this.resultArray = []
      this.zhaoguanFileLogArray = []
      this.isQueryComplete = false
      this.getDataUploadLogList()
    },

    // method
    tableRowClassName({ row }) {
      if (row.isSucceed) {
        return 'succeed-row'
      } else {
        return 'failed-row'
      }
    },

    async getLogData() {
      const startTime = DateTool.millisecondTimestampToStr(this.duration[0], 'Y-M-D h:m:s')
      const endTime = DateTool.millisecondTimestampToStr(this.duration[1], 'Y-M-D h:m:s')
      const params = {
        "keyWord": this.sn,
        "pageNum": 1,
        "pageSize": 5000,
        "startDate": startTime,
        "endDate": endTime,
      };
      const data = await this.$api.bloodOxygenDeviceLog(params);
      this.dataLogArray = data.list.map((item) => {
        return new SmartDiagnoseAlertDataUploadModel(item)
      });
    },
    async getZhaoguanFileLogList(hospitalName) {
      const startTime = DateTool.millisecondTimestampToStr(this.duration[0], 'Y-M-D h:m:s')
      const endTime = DateTool.millisecondTimestampToStr(this.duration[1], 'Y-M-D h:m:s')
      const params = {
        "keyWord": hospitalName,
        "pageNum": 1,
        "pageSize": 5000,
        "startDate": startTime,
        "endDate": endTime,
        "logType": "原始日志"
      };
      const data = await this.$api.bloodOxygenDeviceLog(params);
      this.zhaoguanFileLogArray = data.list.map((item) => {
        return new SmartDiagnoseAlertDataUploadModel(item)
      });
    },

    async getDataUploadLogList() {
      try {
        //通过hospitalName查5000条数据
        await this.getLogData()
        const targetSnLogArray = this.dataLogArray.filter((item) => {
          return item.model.ringSn === this.sn
        })
        //过滤出所有定时的日志
        this.periodLogArray = targetSnLogArray.filter((item) => {
          return item.isSyncPeriodLog
        })
        let hospitalName = ''
        if (this.dataLogArray.length > 0) {
          hospitalName = this.dataLogArray[0].model.hospitalName
        }
        if (!hospitalName) {
          this.$toast.showRed("该指环未上传任何数据")
          return
        }

        await this.getZhaoguanFileLogList(hospitalName)
        //获取开始时间到结束时间的兆冠日志
        let logUrlArray = []
        let index = 0
        while (index < this.zhaoguanFileLogArray.length) {
          const item = this.zhaoguanFileLogArray[index]

          const gmtCreate = dayjs(item.model.gmtCreate)
          if (item.model.logType === '原始日志') {
            if (!logUrlArray.some(url => url === item.model.logContent)) {
              logUrlArray.push(item.model.logContent)
            }
            if (gmtCreate.isSame(dayjs(this.duration[0]), 'day')) {
              break
            }
          }
          index++
        }


        //获取这url对应文件的文本数据。
        // 带logFileNew的是新版日志
        const oldLogListArray = []
        const newLogListArray = []

        for (const url of logUrlArray) {
          const logArray = await this.getLogText(url)
          if (url.includes('/logFileNew/')) {
            newLogListArray.push(logArray)
          } else {
            oldLogListArray.push(logArray)
          }
        }

        // 把logListArray整合成一个
        const oldLogArray = oldLogListArray.reverse().flat()
        const newLogArray = newLogListArray.reverse().flat()
        console.log(oldLogArray);
        console.log(this.periodLogArray);

        this.periodLogArray.forEach((item) => {
          const periodStartTime = dayjs(item.periodStartTime)
          const periodEndTime = dayjs(item.periodEndTime)
          //如果periodEndTime 大于当前时间，说明没监测/没监测完，不处理。
          if (periodEndTime.isAfter(dayjs())) {
            return
          }
          console.log(periodStartTime.format('YYYY-MM-DD HH:mm:ss'), periodEndTime.format('YYYY-MM-DD HH:mm:ss'));
          //ringVersion长度9为老款指环
          if (item.model.ringVersion.length >= 9) {
            //现在找到periodStartTime之前最晚的一条记录
            const tagetText = `sn='${this.sn}'`
            let firstLogIndex = -1
            let lastLogIndex = -1
            let tempStartI = -1
            for (let i = 0; i < oldLogArray.length; i++) {
              const logItem = oldLogArray[i]
              const logItmeArr = logItem?.split(' [INFO] ') || []
              const logTime = dayjs(logItmeArr[0])
              const logContent = logItmeArr[1]

              if (logTime.isBefore(periodStartTime) && logTime.isAfter(periodStartTime.startOf('day'))) {
                if (!!logContent && logContent.startsWith('MegaBleDevice{') && logContent.includes(tagetText)) {
                  tempStartI = i
                }
                if (!!logContent && logContent.startsWith('[cmd] enableV2PeriodMonitor')) {
                  firstLogIndex = tempStartI
                }
              }

              //找到调用过“syncMonitorData”方法的第一次收取数据的位置
              if (logTime.isAfter(periodEndTime) && !!logContent && logContent.startsWith('MegaBleDevice{') && logContent.includes(tagetText)) {
                lastLogIndex = i
              }

              if (lastLogIndex != -1 && !!logContent && logContent.startsWith('[cmd] syncMonitorData')) {
                console.log(firstLogIndex, lastLogIndex);
                if (this.diagnoseType === 1) {
                  const analyseRes = this.analyseLogOld(oldLogArray, firstLogIndex, lastLogIndex)
                  console.log(analyseRes);
                  if (analyseRes) {
                    if (analyseRes.errorCode === 1) {
                      const rlog = oldLogArray[firstLogIndex]
                      const rArr = rlog?.split(' [INFO] ') || []
                      const rTime = dayjs(rArr[0])
                      this.resultArray.push({
                        period: `${item.periodStartTime} ~ ${item.periodEndTime}`,
                        message: `
                        分析结果：${analyseRes.result}。\n

                        相关兆冠日志:\n${logUrlArray.filter(item => item.includes('/logFile/')).join('\n')}\n
                        可以查看${rTime.format('YYYY-MM-DD HH:mm:ss')}那一次连接时相关数据确认。
                      `
                      })
                    }

                    if (analyseRes.errorCode === 2) {
                      const rlog = oldLogArray[firstLogIndex]
                      const rArr = rlog?.split(' [INFO] ') || []
                      const rTime = dayjs(rArr[0])

                      const rlog1 = oldLogArray[lastLogIndex]
                      const rArr1 = rlog1?.split(' [INFO] ') || []
                      const rTime1 = dayjs(rArr1[0])
                      this.resultArray.push({
                        period: `${item.periodStartTime} ~ ${item.periodEndTime}`,
                        message: `
                        分析结果：${analyseRes.result}。\n
                        相关兆冠日志:\n${logUrlArray.filter(item => item.includes('/logFile/')).join('\n')}\n
                        把这几个日志下载后发给兆冠分析。\n
                        ${rTime.format('YYYY-MM-DD HH:mm:ss')}连接时设置了定时， ${rTime1.format('YYYY-MM-DD HH:mm:ss')}收取时无数据。\n
                        询问话术（例）： @多加辣椒 你好，指环SN（${this.sn}），昨天（${rTime.format('YYYY-MM-DD HH:mm:ss')}）设置定时，今天（${rTime1.format('YYYY-MM-DD HH:mm:ss')}）收取无数据，（医院老师相关描述，是否带充电盒， 指环是否亮灯等等）麻烦看一下。
                      `
                      })
                    }
                  }
                } else if (this.diagnoseType === 2) {
                  //如果是对数据有疑问，不分析了，分析不了，直接把报告列出来发给兆冠分析。
                  //找到原始数据，便于恢复或者发给兆冠分析（数据为0情况）
                  const originDataFileList = this.dataLogArray.filter((item) => {
                    return item.model.logType === '原始数据'
                  }).reverse()

                  this.periodLogArray.forEach((item) => {
                    const periodStartTime = dayjs(item.periodStartTime)
                    const periodEndTime = dayjs(item.periodEndTime)
                    if (periodEndTime.isAfter(dayjs())) {
                      return
                    }
                    const firstOriginDataFile = originDataFileList.find((originDataFile) => {
                      return dayjs(originDataFile.model.gmtCreate).isAfter(periodEndTime)
                    })
                    if (firstOriginDataFile) {
                      const rlog = oldLogArray[firstLogIndex]
                      const rArr = rlog?.split(' [INFO] ') || []
                      const rTime = dayjs(rArr[0])

                      const rlog1 = oldLogArray[lastLogIndex]
                      const rArr1 = rlog1?.split(' [INFO] ') || []
                      const rTime1 = dayjs(rArr1[0])
                      this.resultArray.push({
                        period: `${item.periodStartTime} ~ ${item.periodEndTime}`,
                        message: `
                        分析结果：对数据有疑问，不分析了，我们这边分析不了，直接把报告列出来发给兆冠分析。\n
                        报告原始数据：${firstOriginDataFile.model.logContent}\n
                        兆冠SDK日志:\n${logUrlArray.filter(item => item.includes('/logFile/')).join('\n')}\n
                        把这几个日志下载后发给兆冠分析。\n
                        询问话术（例）： @多加辣椒 你好，指环SN（${this.sn}）,昨天（${rTime.format('YYYY-MM-DD HH:mm:ss')}）设置定时，今天（${rTime1.format('YYYY-MM-DD HH:mm:ss')}）收取数据，报告监测时长为0，（医院老师相关描述，是否带充电盒， 指环是否亮灯等等）麻烦看一下。
                      `
                      })
                      console.error(`定时${periodStartTime.format('YYYY-MM-DD HH:mm')}到${periodEndTime.format('YYYY-MM-DD HH:mm')}，原始数据文件${firstOriginDataFile.model.logContent}`)
                    }
                  })
                }


                break
              }
            }
          } else {
            //新版指环先不处理
          }
        })

        // 标记查询完成
        this.isQueryComplete = true

      } catch (error) {
        this.$toast.showRed(error);
        console.log(error)
        this.isQueryComplete = true
      }
    },

    async getRingLogList() {
      try {
        const startTime = DateTool.millisecondTimestampToStr(this.duration[0], 'Y-M-D h:m:s')
        const endTime = DateTool.millisecondTimestampToStr(this.duration[1], 'Y-M-D h:m:s')
        const params = {
          "keyWord": this.sn,
          "pageNum": 1,
          "pageSize": 1000,
          "startDate": startTime,
          "endDate": endTime,
          "logType": "原始日志"
        };
        const data = await this.$api.bloodOxygenDeviceLog(params);
        this.ringLogArray = data.list.map((item) => {
          return new SmartDiagnoseAlertRingLogModel(item)
        });
        this.isQueryComplete = true
      } catch (error) {
        this.$toast.showRed(error);
      }
    },

    async getLogText(url) {
      try {
        const response = await fetch(url);
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        const text = await response.text();
        const logArray = text.split('\n')
        return logArray
      } catch (error) {
        console.error('获取日志文件失败:', error);
        this.$toast.showRed(`获取日志文件失败: ${error.message}`);
        return [];
      }
    },

    analyseLogOld(logArray, firstLogIndex, lastLogIndex) {
      //1 查看是否定时 关键字’enableV2PeriodMonitor‘
      let i = firstLogIndex;
      let enableV2PeriodMonitor = false;
      //
      while (i < logArray.length && i < (firstLogIndex + 2500)) {
        const logItem = logArray[i] // 日志
        const logItmeArr = logItem?.split(' [INFO] ') || []
        const logTime = dayjs(logItmeArr[0])
        const logContent = logItmeArr[1]
        if (!!logContent) {
          if (logContent.includes('enableV2PeriodMonitor')) {
            enableV2PeriodMonitor = true
            break
          }
          if (logContent.includes('Connected to GATT server')) {
            break
          }
        }
        i++
      }
      //查看是否收成数据，关键字’Total length‘、‘syncMonitorData’、 ’No monitor data

      i = lastLogIndex;
      let syncMonitorData = false;
      let syncMonitorDataFinish = false
      while (i < logArray.length && i < (lastLogIndex + 2500)) {
        const logItem = logArray[i] // 日志
        const logItmeArr = logItem?.split(' [INFO] ') || []
        const logTime = dayjs(logItmeArr[0])
        const logContent = logItmeArr[1]
        if (!!logContent) {
          if (logContent.includes('syncMonitorData')) {
            syncMonitorData = true
          }
          if (logContent.includes('totalLen') || logContent.includes('Total length')) {
            syncMonitorDataFinish = true
          }
          if (logContent.includes('Connected to GATT server')) {
            break
          }
        }

        i++
      }
      if (!enableV2PeriodMonitor) {
        return {
          result: '未设置定时',
          errorCode: 1,
        }
      }
      if (syncMonitorData && !syncMonitorDataFinish) {
        return {
          result: '已定时，但是收取无数据，怀疑定时信息失效，建议把相关日志发给兆冠分析',
          errorCode: 2,
        }
      }
      return null
    },

    arrayToTxtDownload(list) {
      console.log(list);
      
      try {
        // 创建Blob对象
        const blob = new Blob([list], { type: 'text/plain' });

        // 创建下载链接
        const url = URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        const fileName = `${this.sn}日志.txt`;
        a.download = fileName;

        // 模拟点击下载
        document.body.appendChild(a);
        a.click();

        // 清理
        document.body.removeChild(a);
        URL.revokeObjectURL(url);
        
        this.$toast.showGreen(`文件 "${fileName}" 已成功生成并开始下载`);
      } catch (error) {
        this.$toast.showRed(`操作失败: ${error.message}`);
        console.error('下载失败:', error);
      }
    }
  },
};
</script>

<style lang="scss" scoped>
.add-device {

  &-top {
    width: 100%;
    height: rem(55);
    border-bottom: rem(1) solid rgba($color: black, $alpha: 0.09);
    box-sizing: border-box;
    padding: rem(0) rem(24);
    display: flex;
    align-items: center;
    justify-content: space-between;

    &-title {
      color: rgba($color: black, $alpha: 0.85);
      font-size: rem(16);

      &-tip {
        color: #F45C50;
        font-size: 12px;
      }
    }

    &-close {
      width: rem(16);
      height: rem(16);
    }
  }

  &-content {
    padding: 10px 20px 50px;
    width: 1050px;

    &-top {
      display: flex;
      align-items: center;
      justify-content: space-between;

      /deep/.el-input {
        width: 220px;
        margin-right: 20px;
      }

      &-diagnose {
        color: white;
        background-color: #325FAC;
        font-size: 14px;
        width: 88px;
        height: 32px;
        border-radius: 4px;
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }

    &-result {
      margin-top: 20px;
      height: 400px;
      overflow: hidden;
      overflow-y: auto;

      &-data-upload-table {
        /deep/.el-table td.el-table__cell div {
          white-space: pre-line;
        }

        /deep/.el-table .failed-row {
          color: #F45C50;
        }
      }

      &-ring-log-table {
        display: flex;
        flex-direction: column;

        &-result {
          margin-bottom: 20px;
        }

        &-cell-content {
          flex: 3;
          display: flex;
          flex-direction: column;

          >a {
            line-height: 30px;
          }
        }
      }
    }
  }
}
</style>